import { render, staticRenderFns } from "./receipt-summary.vue?vue&type=template&id=dc670da6&scoped=true"
import script from "./receipt-summary.vue?vue&type=script&lang=ts"
export * from "./receipt-summary.vue?vue&type=script&lang=ts"
import style0 from "./receipt-summary.vue?vue&type=style&index=0&id=dc670da6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc670da6",
  null
  
)

export default component.exports